import React from 'react';
import PropTypes from 'prop-types';

import './staggered-search-info.scss';

function StaggeredSearchInfo(props) {
  const { tireSizes, wheelSizes } = props;

  const sizes = tireSizes || wheelSizes;
  const { aspectRatio, boltPattern, diameter, width } = sizes?.front || {};
  const {
    aspectRatio: rearAspectRatio,
    boltPattern: rearBoltPattern,
    diameter: rearDiameter,
    width: rearWidth
  } = sizes?.rear || {};
  const productType = tireSizes ? 'Tire' : 'Wheel';

  return (
    <div styleName="container">
      <span styleName="description">{productType} sets by size</span>

      <div styleName={tireSizes ? 'tire-search-info' : 'wheel-search-info'}>
        {sizes?.front && (
          <div styleName="axle-info">
            <strong>
              {tireSizes
                ? `${width}/${aspectRatio}R${diameter}`
                : `${diameter} ${(width || boltPattern) && 'X'} ${
                    width && width + ' '
                  }${boltPattern}`}
            </strong>
            <br />
            <span styleName="axle-info-label">Front {productType} Size</span>
          </div>
        )}

        {sizes?.rear && (
          <div styleName="axle-info">
            <strong>
              {tireSizes
                ? `${rearWidth}/${rearAspectRatio}R${rearDiameter}`
                : `${rearDiameter} ${(rearWidth || rearBoltPattern) && 'X'} ${
                    rearWidth && rearWidth + ' '
                  }${rearBoltPattern}`}
            </strong>
            <br />
            <span styleName="axle-info-label">Rear {productType} Size</span>
          </div>
        )}
      </div>
    </div>
  );
}

StaggeredSearchInfo.propTypes = {
  tireSizes: PropTypes.object,
  wheelSizes: PropTypes.object
};

export default StaggeredSearchInfo;
